import React from 'react'
import cn from 'classnames'

export default function Center({
  children,
  className,
  alignment = 'center',
}: {
  children: React.ReactNode
  className?: string
  alignment?: 'center' | 'left'
}) {
  const alignmentClass = {
    center: null,
    left: 'mc-mr-auto',
  }
  return (
    <div
      className={cn(
        {
          'col-auto': !className?.includes('col-'),
        },
        alignmentClass[alignment],
        className,
      )}
    >
      {children}
    </div>
  )
}
